import { Box, Flex } from '../../../shared/layouts';
import CheckmarkSvg from 'imagesUwKluis/svg/checkmark.svg';
import { useEffect, useRef, useState } from 'react';

const ProcessStep = ({
  index,
  activeStepIndex,
  isCurrent,
  isCompleted,
  onClickCallback,
  processBar,
}) => {
  const [isActive, setActive] = useState();
  const step = useRef();
  const size = isActive ? '38px' : '20px';

  useEffect(() => {
    setActive(activeStepIndex === index);
  }, [index, activeStepIndex]);

  useEffect(() => {
    // Scroll the active step into the 'center' of the scrollbar
    if (processBar.current && step.current && isActive) {
      const stepElement = step.current;
      const barElement = processBar.current;

      const remainingSpace = barElement.clientWidth - stepElement.offsetWidth;
      const spaceLeftAndRight = remainingSpace / 2;
      barElement.scrollLeft = stepElement.offsetLeft - spaceLeftAndRight;
    }
  }, [processBar, step, isActive]);

  let innerBackgroundColor = isCurrent || isCompleted ? 'secondary' : 'white';

  return (
    <Box ref={step} zIndex={2}>
      <Flex
        boxSizing={'border-box'}
        height={size}
        width={size}
        justifyContent={'center'}
        alignItems={'center'}
        flexShrink={0}
        display={'inline-block'}
        bg={isActive ? 'white' : ''}
        border={isActive ? '2px solid' : ''}
        borderColor={'secondary'}
        borderRadius={'50%'}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          onClickCallback(index);
        }}
      >
        <Box
          boxSizing={'border-box'}
          width={'20px'}
          height={'20px'}
          position={'relative'}
          border={!isCompleted && !isCurrent ? '2px solid' : ''}
          borderColor={'secondary'}
          bg={innerBackgroundColor}
          borderRadius={'50%'}
        >
          {isCompleted && (
            <CheckmarkSvg
              css={(theme) => ({
                position: 'absolute',
                top: '6px',
                left: '3px',
                display: 'inline-block',
                width: '13px',
                fill: theme.colors.white,
              })}
            />
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default ProcessStep;
